<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-cart">

        <page-title :title="'Koszyk'" :back="true"></page-title>

        <div v-if="cart && cart.products && cart.products.length != 0">
            <div v-for="(item,index) in cart.products" :key="item.slug">
                <item-cart
                        :index="index"
                        :id="item.id"
                        :slug="item.slug"
                        :name="item.name"
                        :description="item.description"
                        :price="item.price"
                        :priceString="item.priceString"
                        :badge="item.badge"
                        :image="item.image">
                </item-cart>
            </div>
        </div>
        <div v-else>
            <p class="text-center mt-20">Brak produków</p>
        </div>

        <hr>

        <ion-row>
            <ion-col class="text-left">
                <h3 style="display: inline-block; margin: 0">Suma brutto</h3>
            </ion-col>
            <ion-col class="text-right">
                <h3 style="display: inline-block; margin: 0">{{ cart.summary ? cart.summary.summary : 0 }}</h3>
            </ion-col>
        </ion-row>

        <ion-button mode="ios" expand="block" class="mt-10">Przejdź dalej</ion-button>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import ItemCart from '@/items/ItemCart';

    export default {
        name: 'CartIndex',
        components: { PageTitle, ItemCart },
        computed: {
            ...mapState({
                loading: state => state.shopGlass.loading,
                cart: state => state.shopGlass.cart
            })
        },
        mounted(){
            this.$store.dispatch('shopGlass/SHOP_GLASS_CART_REQUEST');
        },
        methods: {

        }
    }
</script>